import * as React from "react";
import { Button, Modal } from "semantic-ui-react";

import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";
import { MedicalTypeId } from "@teamprevent/common/healthSurveillance";
import Utils from "@teamprevent/common/utils";
import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";

import { SAVE_WORKGROUP } from "../actiontypes";
import { WorkGroupEditModel } from "../model";
import { workGroupApi } from "../workGroupApi";

import { DispatchProps, EditProps, EditUnconnected as Edit } from "./Edit";
import { BaseProps } from "./Base";

interface State {
    initialMedicals: MedicalTypeId[];
    currentMedicals: MedicalTypeId[];
    employeesInWorkGroup: number;
}

export class EditModal extends React.Component<EditProps & DispatchProps & BaseProps, State> {
    constructor(props: EditProps & DispatchProps & BaseProps) {
        super(props);
        this.state = { initialMedicals: undefined, currentMedicals: undefined, employeesInWorkGroup: undefined };
        this.onClose = this.onClose.bind(this);
        this.onMedicalsChanged = this.onMedicalsChanged.bind(this);
        this.getSaveButton = this.getSaveButton.bind(this);
    }

    private editForm: Edit;

    public async componentDidMount() {
        const employeesInWorkGroup = await workGroupApi.getEmployeesInWorkGroupCount(this.props.customer.id, this.props.model.id);
        this.setState({
            initialMedicals: this.props.model.medicals,
            currentMedicals: this.props.model.medicals,
            employeesInWorkGroup
        });
    }

    public componentDidUpdate() {
        const hasStateBeenCleared = this.state.initialMedicals === undefined && this.state.currentMedicals === undefined;
        const workGroupLoaded = !!this.props.model?.medicals;
        if (hasStateBeenCleared && workGroupLoaded) {
            this.setState({
                initialMedicals: this.props.model.medicals,
                currentMedicals: this.props.model.medicals
            });
        }
    }

    public render() {
        const model: WorkGroupEditModel = {
            ...this.props.model,
            medicals: this.state.currentMedicals ?? this.props.model?.medicals
        };
        return (
            <Modal size="small" open={this.props.open} onClose={this.props.close} closeOnDimmerClick={false}>
                <Modal.Header>Edit Work Group</Modal.Header>
                <Modal.Content>
                    <Edit
                        loadWorkGroups={this.props.loadWorkGroups}
                        close={this.props.close}
                        workGroups={this.props.workGroups}
                        open={this.props.open}
                        save={this.props.save}
                        model={model}
                        ref={instance => this.editForm = instance}
                        customer={this.props.customer}
                        onMedicalsChanged={this.onMedicalsChanged}
                        medicalTypeOptions={this.props.medicalTypeOptions}
                    />
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.onClose}>Cancel</Button>
                    {this.getSaveButton()}
                </Modal.Actions>
            </Modal>
        );
    }

    private onClose() {
        this.setState({
            initialMedicals: undefined,
            currentMedicals: undefined
        }, () => this.props.close());
    }

    private onMedicalsChanged(medicals: MedicalTypeId[]) {
        this.setState({
            currentMedicals: medicals
        });
    }

    private getSaveButton() {
        const haveMedicalsChanged = !Utils.IsStringArraysContentEqual(this.state.initialMedicals, this.state.currentMedicals);
        return haveMedicalsChanged
            ? (<ConfirmedButton
                content="Save"
                onClick={() => this.onSubmit()}
                promptText={`There are ${this.state.employeesInWorkGroup} employees on the work group - by adding or removing a medical
                    the system will update Health Surveillance cases accordingly. Are you sure you want to do this?
                    Type 'EDIT' and click confirm to edit the work group.`
                }
                typeToConfirmText="EDIT"
                headingText="Edit Work Group"
            />)
            : <IsLoadingButton requestNames={SAVE_WORKGROUP} content="Save" onClick={this.onSubmit} />;
    }

    private onSubmit = () => this.editForm.submit();
}
